<script lang="ts">
    import { _ } from 'svelte-i18n';
    import TemplateSettingsGeneral from './TemplateSettingsGeneral.svelte';
    import SettingsRow from './SettingsRow.svelte';
    import SettingsRowLabel from './SettingsRowLabel.svelte';
    import SettingsRowValue from './SettingsRowValue.svelte';
    import { app } from '../../../stores/app';

    // Pole tylko do odczytu. Zgodnie z logiką w TargeoMap.svelte: 'pl' => Polska, pozostałe ('eu'/null) => Europa.
    $: areaLabel = $app.settingsReadonly?.allowed_area === 'pl' ? $_('Poland') : $_('Europe');
</script>

<TemplateSettingsGeneral>
    <div slot="label">{$_('Available area')}</div>
    <div slot="content">
        <SettingsRow>
            <SettingsRowLabel>{$_('Area')}</SettingsRowLabel>
            <SettingsRowValue>{areaLabel}</SettingsRowValue>
        </SettingsRow>
    </div>
</TemplateSettingsGeneral>
